import React, { PureComponent } from "react";
import PT from "prop-types";

import { Header, Paragraph, List, ListItem } from "./";
import { EditorJsVarsStyle } from "./editorjs_vars";

export default class EditorJsRenderer extends PureComponent {
    static propTypes = {
        blocks: PT.array,
        blocks_json: PT.any,
    };
    render() {
        let { blocks, blocks_json } = this.props;
        if (blocks_json) {
            blocks = JSON.parse(blocks_json);
        }
        return (
            <>
                {blocks.map((block, idx) => {
                    switch (block.type) {
                        case "header":
                            return (
                                <Header
                                    key={idx}
                                    level={block.data.level}
                                    dangerouslySetInnerHTML={{
                                        __html: block.data.text,
                                    }}
                                />
                            );
                        case "paragraph":
                            return (
                                <Paragraph
                                    key={idx}
                                    dangerouslySetInnerHTML={{
                                        __html: block.data.text,
                                    }}
                                />
                            );
                        case "list":
                            return (
                                <List key={idx} type={block.data.style}>
                                    {block.data.items.map((i, idx) => (
                                        <ListItem
                                            type={block.data.style}
                                            key={idx}
                                            dangerouslySetInnerHTML={{
                                                __html: i,
                                            }}
                                        />
                                    ))}
                                </List>
                            );
                        default:
                            return (
                                <Paragraph key={idx}>
                                    Неизвестный тип: {block.type}
                                </Paragraph>
                            );
                    }
                })}
                <EditorJsVarsStyle />
            </>
        );
    }
}
